// extracted by mini-css-extract-plugin
export default {"container":"TableView_container__Etzch","table":"TableView_table__JdVSq","th":"TableView_th__d55sw","td":"TableView_td__aPkGx","tr":"TableView_tr__fPRlC"};